<template lang="html">
  <Loader v-if="isDataLoading"/>
  <div v-else class="container">
      <div v-html="cgu" class="wysiwyg" />
  </div>
</template>

<script>
import CGU from '@/api/cgu';
import Loader from '@/components/Loader.vue';

export default {
  name: 'cgus',
  components: {
    Loader
  },
  data: () => ({
      cgu: '',
      isDataLoading: true
  }),
  computed: {
  },
  created() {
    this.getCgu()
  },
  methods: {
    getCgu() {
      CGU.get().then((res) => {
        this.cgu = res.data.cgu;
        this.isDataLoading = false;
      });
    },
  },
};
</script>
